import fetchCreateRoom, {
  FetchCreateRoomOptions
} from "../api/fetch-create-room";
import { useAuth } from "../context/AuthContext";

export default function useFetchCreateRoom() {
  const authCtx = useAuth();
  return authCtx.user
    ? (options: FetchCreateRoomOptions) =>
        authCtx.getIdToken().then((token) => fetchCreateRoom(token, options))
    : () => Promise.reject("Not authorized");
}
